<template>
  <div class="custom-section-box" v-if="editData">
    <div>
      <div class="title" style="padding-bottom: 0;">Personal Information</div>
      <div class="ant-table ant-table-scroll-position-left ant-table-default">
        <div class="ant-table-content">
          <div class="ant-table-body">
            <table>
              <!-- <thead class="ant-table-thead">
                <tr>
                  <th class="ant-table-row-cell-break-word td-checkbox" v-if="!isMainShow">
                    <a-checkbox />
                  </th>
                  <th class="ant-table-row-cell-break-word"></th>
                </tr>
              </thead> -->
              <tbody class="ant-table-tbody">
                <tr class="ant-table-row">
                  <td v-if="!isMainShow" class="td-checkbox">
                    <a-checkbox 
                      :disabled="!editData.title" 
                      v-model="checkedItems.title"
                      @change="handleCheckboxChange('title', $event)"
                    />
                  </td>
                  <td><strong>Title:</strong>{{ editData.titleObj ? editData.titleObj.enName : null }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.lastName"
                      v-model="checkedItems.lastName"
                      @change="handleCheckboxChange('lastName', $event)"
                    />
                  </td>
                  <td><strong>Last Name:</strong>{{ editData.lastName }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.firstName"
                      v-model="checkedItems.firstName"
                      @change="handleCheckboxChange('firstName', $event)"
                    />
                  </td>
                  <td><strong>First Name:</strong>{{ editData.firstName }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.middleName"
                      v-model="checkedItems.middleName"
                      @change="handleCheckboxChange('middleName', $event)"
                    />
                  </td>
                  <td><strong>Middle Name:</strong>{{ editData.middleName }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.preferToBeCalled"
                      v-model="checkedItems.preferToBeCalled"
                      @change="handleCheckboxChange('preferToBeCalled', $event)"
                    />
                  </td>
                  <td><strong>Nickname:</strong>{{ editData.preferToBeCalled }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.gender"
                      v-model="checkedItems.gender"
                      @change="handleCheckboxChange('gender', $event)"
                    />
                  </td>
                  <td><strong>Gender:</strong>{{ editData.gender == 'M' ? 'Male' : 'Female' }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.birthday"
                      v-model="checkedItems.birthday"
                      @change="handleCheckboxChange('birthday', $event)"
                    />
                  </td>
                  <td><strong>Birthdate:</strong>{{ dateFormatB(editData.birthday) }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.languages"
                      v-model="checkedItems.languages"
                      @change="handleCheckboxChange('languages', $event)"
                    />
                  </td>
                  <td><strong>Primary language:</strong>{{ editData.languageObj ? editData.languageObj.enName : '' }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow"><a-checkbox :disabled="!editData.otherLanguageNames" /></td>
                  <td><strong>Other languages:</strong>{{ editData.otherLanguageNames }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.nationalBackground"
                      v-model="checkedItems.nationalBackground"
                      @change="handleCheckboxChange('nationalBackground', $event)"
                    />
                  </td>
                  <td><strong>Origin:</strong>{{ editData.nationalBackgroundObj ? editData.nationalBackgroundObj.enName : '' }}</td>
                </tr>
                <tr class="ant-table-row">
                  <td v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.ethnicitiesId"
                      v-model="checkedItems.ethnicitiesId"
                      @change="handleCheckboxChange('ethnicitiesId', $event)"
                    />
                  </td>
                  <td><strong>Ethnicities:</strong>{{ editData.ethnicitiesObj ? editData.ethnicitiesObj.enName : '' }}</td>
                </tr>
                <template v-if="editData.contactList && editData.contactList.length > 0">
                  <tr class="ant-table-row" v-for="(item, index) in editData.contactList.filter(e => e.contactType == '1')" :key="item.id + '-' + index">
                    <td v-if="!isMainShow">
                      <a-checkbox 
                        :disabled="!item.email"
                        :checked="item.isChecked" 
                        @change="e => handleContactCheckChange(e, item, 'email')" 
                      />
                    </td>
                    <td :class="{ 'email-row': true, 'first-email': index == 0 }">
                      <template v-if="index == 0"><strong>Email:</strong></template>
                      <span class="email-value">{{ item.email }}</span>
                    </td>
                  </tr>
                </template>
                <template v-if="editData.contactList && editData.contactList.length > 0">
                  <tr class="ant-table-row" v-for="(item, index) in editData.contactList.filter(e => e.contactType == '2')" :key="item.id + '-' + index">
                    <td v-if="!isMainShow">
                      <a-checkbox 
                        :disabled="!(item.phoneCountryCallingCode && item.phoneNumber)"
                        :checked="item.isChecked" 
                        @change="e => handleContactCheckChange(e, item, 'phoneNumber')" 
                      />
                    </td>
                    <td :class="{ 'phone-row': true, 'first-phone': index == 0 }">
                      <template v-if="index == 0"><strong>Phone:</strong></template>
                      <span class="phone-value"><template v-if="item.phoneCountryCallingCode && item.phoneNumber">+{{ item.phoneCountryCallingCode }} {{ item.phoneNumber }}</template> <template v-if="item.phoneExt">Ext.{{ item.phoneExt }}</template></span>
                    </td>
                  </tr>
                </template>
                <template v-if="specialData">
                  <tr class="ant-table-row">
                    <td v-if="!isMainShow">
                      <a-checkbox
                        :disabled="!specialData.roomPreferred"
                        v-model="checkedItems.roomPreferred"
                        @change="handleCheckboxChange('roomPreferred', $event)"
                      />
                    </td>
                    <td>
                      <strong>Room Prefer:</strong>
                      <template v-if="specialData.roomPreferred">
                        {{ specialData.roomPreferred == '1' ? 'TWN' : 'DBL' }}
                      </template>
                    </td>
                  </tr>
                  <template v-if="specialData.mealsRequestName && specialData.mealsRequestName.length > 0">
                    <tr class="ant-table-row" v-for="(item, index) in specialData.mealsRequestName" :key="item.code + '-' + index">
                      <td v-if="!isMainShow">
                        <a-checkbox
                          :disabled="!specialData.mealsRequest"
                          :checked="isMealRequestSelected(item.code)"
                          @change="e => handleMealRequestChange(e, item)"
                        />
                      </td>
                      <td :class="{ 'restriction-row': true, 'first-restriction': index == 0 }">
                        <template v-if="index == 0"><strong>Meal Restriction:</strong></template>
                        <span class="restriction-value">{{ formatName(item) }}</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr class="ant-table-row">
                      <td v-if="!isMainShow"><a-checkbox :disabled="true" /></td>
                      <td><strong>Meal Restriction:</strong></td>
                    </tr>
                  </template>
                  <template v-if="specialData.specialRequestName && specialData.specialRequestName.length > 0">
                    <tr class="ant-table-row" v-for="(item, index) in specialData.specialRequestName" :key="item.code + '-' + index">
                      <td v-if="!isMainShow">
                        <a-checkbox
                          :disabled="!specialData.specialRequest"
                          :checked="isSpecialRequestSelected(item.code)"
                          @change="e => handleSpecialRequestChange(e, item)"
                        />
                      </td>
                      <td :class="{ 'request-row': true, 'first-request': index == 0 }">
                        <template v-if="index == 0"><strong>Special Request:</strong></template>
                        <span class="request-value">{{ formatName(item) }}</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr class="ant-table-row">
                      <td v-if="!isMainShow"><a-checkbox :disabled="true" /></td>
                      <td><strong>Special Request:</strong></td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="title title-padding">Mailing info</div>
      <div class="ant-table ant-table-scroll-position-left ant-table-default">
        <div class="ant-table-content">
          <div class="ant-table-body">
            <table>
              <thead class="ant-table-thead">
                <tr>
                  <th class="ant-table-row-cell-break-word td-checkbox" v-if="!isMainShow"></th>
                  <th class="ant-table-row-cell-break-word">Country</th>
                  <th class="ant-table-row-cell-break-word">Address</th>
                  <th class="ant-table-row-cell-break-word">City</th>
                  <th class="ant-table-row-cell-break-word">State/Province</th>
                  <th class="ant-table-row-cell-break-word">Zip</th>
                </tr>
              </thead>
              <tbody class="ant-table-tbody">
                <template v-if="hasValidAddress(editData.addressList)">
                  <tr class="ant-table-row" v-for="(item, index) in editData.addressList" :key="item.id + '-' + index">
                    <td v-if="!isMainShow" class="td-checkbox">
                      <a-checkbox 
                        :disabled="!hasValidAddress(editData.addressList)"
                        :checked="item.isChecked" 
                        @change="e => handleAddressCheckChange(e, item)" 
                      />
                    </td>
                    <td>{{ item.country ? item.country.nameEnUs : '' }}</td>
                    <td>{{ item.detail }}</td>
                    <td>{{ item.cityInput }}</td>
                    <td>{{ item.state ? item.state.nameEnUs : '' }}</td>
                    <td>{{ item.zipcode }}</td>
                  </tr>
                </template>
                <tr class="ant-table-row" v-else>
                  <td colspan="6"><a-empty :image="simpleImage" description="No Data" /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="emergencyContact">
      <div class="title title-padding">Emergency Contact</div>
      <div class="ant-table ant-table-scroll-position-left ant-table-default">
        <div class="ant-table-content">
          <div class="ant-table-body">
            <table>
              <thead class="ant-table-thead">
                <tr>
                  <th class="ant-table-row-cell-break-word td-checkbox" v-if="!isMainShow"></th>
                  <th class="ant-table-row-cell-break-word">Relationship</th>
                  <th class="ant-table-row-cell-break-word">Last Name</th>
                  <th class="ant-table-row-cell-break-word">First Name</th>
                  <th class="ant-table-row-cell-break-word">E-Mail</th>
                  <th class="ant-table-row-cell-break-word">Contact number</th>
                </tr>
              </thead>
              <tbody class="ant-table-tbody">
                <tr class="ant-table-row" v-if="emergencyContact.realationShipName || emergencyContact.lastName || emergencyContact.firstName || emergencyContact.phoneNumber || emergencyContact.phoneExt || emergencyContact.email">
                  <td v-if="!isMainShow" class="td-checkbox">
                    <a-checkbox 
                      :disabled="!(emergencyContact.realationShipName || emergencyContact.lastName || emergencyContact.firstName || emergencyContact.phoneNumber || emergencyContact.phoneExt || emergencyContact.email)"
                      :checked="!!selectedEmergencyContact"
                      @change="handleEmergencyContactCheckChange"
                    />
                  </td>
                  <td>{{ emergencyContact.realationShipName }}</td>
                  <td>{{ emergencyContact.lastName }}</td>
                  <td>{{ emergencyContact.firstName }}</td>
                  <td>{{ emergencyContact.email }}</td>
                  <td>{{ emergencyContact.phoneNumber }} <template v-if="emergencyContact.phoneExt">Ext.{{ emergencyContact.phoneExt }}</template></td>
                </tr>
                <tr class="ant-table-row" v-else>
                  <td colspan="6"><a-empty :image="simpleImage" description="No Data" /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="title title-padding">Relationship</div>
      <div class="ant-table ant-table-scroll-position-left ant-table-default">
        <div class="ant-table-content">
          <div class="ant-table-body">
            <table>
              <thead class="ant-table-thead">
                <tr>
                  <th class="ant-table-row-cell-break-word td-checkbox" v-if="!isMainShow">
                    <a-checkbox
                      :disabled="!editData.rsList || editData.rsList.length == 0"
                      :indeterminate="selectedRelationships.length > 0 && selectedRelationships.length < (editData.rsList ? editData.rsList.length : 0)"
                      :checked="isAllRelationshipsSelected"
                      @change="handleSelectAllRelationships"
                    />
                  </th>
                  <th class="ant-table-row-cell-break-word">Relationship</th>
                  <th class="ant-table-row-cell-break-word">Global No.</th>
                </tr>
              </thead>
              <tbody class="ant-table-tbody">
                <template v-if="editData.rsList && editData.rsList.length > 0">
                  <tr class="ant-table-row" v-for="(item, index) in editData.rsList" :key="item.id + '-' + index">
                    <td v-if="!isMainShow" class="td-checkbox">
                      <a-checkbox 
                        :checked="selectedRelationships.some(obj => obj.id == item.id)"
                        @change="e => handleRelationshipCheckChange(e, item)"
                      />
                    </td>
                    <td>{{ item.relationshipId ? (realationShipList.find(e => e.id == item.relationshipId).rsName) : '' }}</td>
                    <td>{{ item.globalCode }}</td>
                  </tr>
                </template>
                <tr class="ant-table-row" v-else>
                  <td colspan="3"><a-empty :image="simpleImage" description="No Data" /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RealationShip } from '@/utils/helper/standard-code-utils'
import { Empty } from 'ant-design-vue'
import { Meals, Special } from '@/utils/helper/dict-cdb-utils'

export default {
  name: 'CdbCustomerBasicMerge',
  components: {
    Empty
  },
  props: {
    initData: {
      type: [Object],
      default: null
    },
    titleList: {
      type: [Array],
      default: null
    },
    backgroundList: {
      type: [Array],
      default: null
    },
    ethnicitiesList: {
      type: [Array],
      default: null
    },
    languageList: {
      type: [Array],
      default: null
    },
    initEmergencyContact: {
      type: [Object],
      required: true
    },
    realationShipList: {
      type: [Array],
      default: null
    },
    isMainShow: {
      type: Boolean,
      default: false
    },
    tourData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      editData: null,
      contactList: RealationShip.dict,
      emergencyContact: null,
      specialData: null,
      mealsList: [],
      specialList: [],
      checkedItems: {
        title: false,
        firstName: false,
        lastName: false,
        middleName: false,
        preferToBeCalled: false,
        gender: false,
        birthday: false,
        languages: false,
        otherLanguages: false,
        nationalBackground: false,
        ethnicitiesId: false,
        roomPreferred: false,
        mealsRequest: false,
        specialRequest: false,
        emergencyContact: false
      },
      selectedBasic: null,
      selectedEmailList: [],
      selectedPhoneList: [],
      selectedMealsRequests: [],
      selectedSpecialRequests: [],
      selectedAddressList: [],
      selectedEmergencyContact: null,
      selectedRelationships: [],
      isAllRelationshipsSelected: false
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 初始化数据
    async loadData() {
      this.mealsList = await Meals.getDict()
      this.specialList = await Special.getDict()
      this.editData = this.initData
      if (this.editData) {
        if (this.editData.contactList && this.editData.contactList.length > 0) {
          this.editData.contactList.forEach(item => {
            item.isChecked = false
          })
        }
        if (this.editData.addressList && this.editData.addressList.length > 0) {
          this.editData.addressList.forEach(item => {
            item.isChecked = false
          })
        }
        if (this.editData.rsList && this.editData.rsList.length > 0) {
          this.editData.rsList = this.editData.rsList.filter(e => e.relationshipId || e.globalCode)
        }
      }
      this.emergencyContact = this.initEmergencyContact
      this.specialData = this.tourData
      const titleObj = this.titleList.find(e => e.code == this.editData.title)
      const languageObj = this.languageList.find(e => e.code == this.editData.languages)
      const nationalBackgroundObj = this.backgroundList.find(e => e.code == this.editData.nationalBackground)
      const ethnicitiesObj = this.ethnicitiesList.find(e => e.code == this.editData.ethnicitiesId)
      if (titleObj) {
        this.editData.titleObj = titleObj
      }
      if (languageObj) {
        this.editData.languageObj = languageObj
      }
      if (nationalBackgroundObj) {
        this.editData.nationalBackgroundObj = nationalBackgroundObj
      }
      if (ethnicitiesObj) {
        this.editData.ethnicitiesObj = ethnicitiesObj
      }
      if (this.emergencyContact && this.contactList && this.contactList.length > 0) {
        const relation = this.contactList.find(e => e.code == this.emergencyContact.realationShip)
        if (relation) {
          this.emergencyContact.realationShipName = relation.enName
        }
      }
      if (this.editData.otherLanguages && this.languageList) {
        this.editData.otherLanguageNames = this.getOtherLanguageNames()
      }

      // 餐食需求
      if (this.specialData.mealsRequest?.trim()) {
        this.specialData.mealsRequestName = this.specialData.mealsRequest.split(',')
          .map(code => {
            const found = this.mealsList.find(item => item.code == code.trim())
            return found || { enName: code, twName: code }
          })
          .filter(item => item.enName && item.twName)
      } else {
        this.specialData.mealsRequestName = []
      }

      // 特别需求 (同理)
      if (this.specialData.specialRequest?.trim()) {
        this.specialData.specialRequestName = this.specialData.specialRequest.split(',')
          .map(code => {
            const found = this.specialList.find(item => item.code == code.trim())
            return found || { enName: code, twName: code }
          })
          .filter(item => item.enName && item.twName)
      } else {
        this.specialData.specialRequestName = []
      }
		},
    formatName (item) {
      return item?.enName ? `${item.enName}/${item.twName}` : ''
    },
    getOtherLanguageNames() {
      if (!this.editData.otherLanguages || !this.languageList) return ''
      const languageCodes = this.editData.otherLanguages
        .split(',')
        .map(code => code.trim())
        .filter(code => code)

      const languageNames = languageCodes.map(code => {
        const lang = this.languageList.find(item => item.code == code)
        return lang ? lang.enName : null
      }).filter(name => name)

      return languageNames.join(', ')
    },
    formatAddress (item) {
      if (!item) return ''
      const parts = [
        item.detail,
        item.cityInput,
        item.state?.nameEnUs,
        item.zipcode
      ].filter(Boolean)
      
      return [
        parts.join(', '),
        item.country?.code
      ].filter(Boolean).join(', ')
    },
    hasValidAddress (addressList) {
      if (!addressList?.length) return false
      return addressList.some(item => {
        return (item.detail && item.detail.trim()) || 
              (item.cityInput && item.cityInput.trim()) || 
              (item.state && item.state.nameEnUs && item.state.nameEnUs.trim()) || 
              (item.zipcode && item.zipcode.trim()) || 
              (item.country && item.country.code)
      })
    },
    getActualValue(fieldName) {
      switch(fieldName) {
        case 'title':
          return this.editData.title
        case 'firstName':
          return this.editData.firstName
        case 'lastName':
          return this.editData.lastName
        case 'middleName':
          return this.editData.middleName
        case 'preferToBeCalled':
          return this.editData.preferToBeCalled
        case 'gender':
          return this.editData.gender
        case 'birthday':
          return this.editData.birthday
        case 'languages':
          return this.editData.languages
        case 'otherLanguages':
          return this.editData.otherLanguages
        case 'nationalBackground':
          return this.editData.nationalBackground
        case 'ethnicitiesId':
          return this.editData.ethnicitiesId
        case 'roomPreferred':
          return this.specialData.roomPreferred
        case 'mealsRequest':
          return this.getSelectedMealsRequestString()
        case 'specialRequest':
          return this.getSelectedSpecialRequestString()
        case 'emergencyContact':
          return this.selectedEmergencyContact
        default:
          return null
      }
    },
    getSelectedFieldsAndValues () { 
      const result = {}
      Object.keys(this.checkedItems).forEach(field => {
        if (this.checkedItems[field]) {
          // 只获取选中字段的值
          const value = this.getActualValue(field)
          if (value !== null && value !== undefined) {
            result[field] = value
          }
        }
      })
      return result
    },
    
    getFormattedSelectedValues () { 
      const selected = this.getSelectedFieldsAndValues()
      return selected
    },
    
    handleCheckboxChange (field, e) { 
      const isChecked = e.target.checked
      this.$set(this.checkedItems, field, isChecked)
      const allSelected = this.getSelectedFieldsAndValues()
      this.selectedBasic = allSelected
      console.log('allSelected', allSelected)
    },
    handleContactCheckChange (e, item, type) {
      const checked = e.target.checked
      item.isChecked = checked
      if (type == 'email') {
        this.selectedEmailList = this.editData.contactList.filter(contact => 
          contact.contactType == '1' && contact.isChecked
        )
      } else if (type == 'phoneNumber') {
        this.selectedPhoneList = this.editData.contactList.filter(contact => 
          contact.contactType == '2' && contact.isChecked
        )
      }
      this.$forceUpdate()
    }, 
    updateSelectedArray (array, code, checked) {
      if (checked) {
        if (!array.includes(code)) {
          array.push(code)
        }
      } else {
        const index = array.indexOf(code)
        if (index > -1) {
          array.splice(index, 1)
        }
      }
    },
    updateSelectionState (checkedItemKey, selectedArray) {
      this.checkedItems[checkedItemKey] = selectedArray.length > 0
      const allSelected = this.getSelectedFieldsAndValues()
      this.selectedBasic = allSelected
      this.$forceUpdate()
    },
    handleMealRequestChange (e, item) {
      const checked = e.target.checked
      const code = item.code
      this.updateSelectedArray(this.selectedMealsRequests, code, checked)
      this.updateSelectionState('mealsRequest', this.selectedMealsRequests)
    },
    handleSpecialRequestChange (e, item) {
      const checked = e.target.checked
      const code = item.code
      this.updateSelectedArray(this.selectedSpecialRequests, code, checked)
      this.updateSelectionState('specialRequest', this.selectedSpecialRequests)
    },
    isMealRequestSelected (code) {
      return this.selectedMealsRequests.includes(code)
    },
    isSpecialRequestSelected (code) {
      return this.selectedSpecialRequests.includes(code)
    },
    getSelectedMealsRequestString () {
      return this.selectedMealsRequests.join(',')
    },
    getSelectedSpecialRequestString () {
      return this.selectedSpecialRequests.join(',')
    },
    handleAddressCheckChange (e, item) {
      const checked = e.target.checked
      item.isChecked = checked
      this.selectedAddressList = this.editData.addressList.filter(i => i.isChecked)
      this.$forceUpdate()
    },
    handleEmergencyContactCheckChange (e) {
      const checked = e.target.checked
      this.checkedItems.emergencyContact = checked
      if (checked) {
        this.selectedEmergencyContact = { ...this.emergencyContact }
      } else {
        this.selectedEmergencyContact = null
      }
      const allSelected = this.getSelectedFieldsAndValues()
      this.selectedBasic = allSelected
      this.$forceUpdate()
    },
    handleSelectAllRelationships (e) {
      const checked = e.target.checked
      this.isAllRelationshipsSelected = checked
      if (checked && this.editData.rsList) {
        this.selectedRelationships = [...this.editData.rsList]
      } else {
        this.selectedRelationships = []
      }
      this.$forceUpdate()
    },
    handleRelationshipCheckChange (e, item) {
      const checked = e.target.checked
      const itemId = item.id
      if (checked) {
        if (!this.selectedRelationships.some(obj => obj.id == itemId)) {
          this.selectedRelationships.push(item)
        }
      } else {
        const index = this.selectedRelationships.findIndex(obj => obj.id == itemId)
        if (index > -1) {
          this.selectedRelationships.splice(index, 1)
        }
      }
      if (this.editData.rsList) {
        this.isAllRelationshipsSelected = this.selectedRelationships.length == this.editData.rsList.length
      }
      this.$forceUpdate()
    }
	},
  watch: {
  }
}
</script>
<style lang="less" scoped>
.custom-section-box {
  color: #333;
  font-size: 16px;
  .title-padding {
    padding: 15px 0 5px 0;
  }
  strong {
    color: #333;
    margin-right: 8px;
  }
  .td-checkbox {
    width: 36px;
  }
  .email-row {
    .email-value {
      margin-left: 50px;
    }
    &.first-email .email-value {
      margin-left: 0;
    }
  }
  .phone-row {
    .phone-value {
      margin-left: 54px;
    }
    &.first-phone .phone-value {
      margin-left: 0;
    }
  }
  .restriction-row {
    .restriction-value {
      margin-left: 120px;
    }
    &.first-restriction .restriction-value {
      margin-left: 0;
    }
  }
  .request-row {
    .request-value {
      margin-left: 116px;
    }
    &.first-request .request-value {
      margin-left: 0;
    }
  }
}
</style>
